import brandLogoUrl from '../assets/brand-logo.jpg';

/** 品牌 Logo（Vite 打包进 assets，避免 public 中文文件名部署丢失） */
export const APP_LOGO = brandLogoUrl;
export const APP_LOGO_ALT = '曲水稻香';
export const APP_NAME = '曲水稻香';
